/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseEntity } from '../models/BaseResponseEntity';
import type { CertificateResponseEntity } from '../models/CertificateResponseEntity';
import type { CreateCertificateDto } from '../models/CreateCertificateDto';
import type { DeleteDocumentResponseEntity } from '../models/DeleteDocumentResponseEntity';
import type { DeleteSignatureImgResponseEntity } from '../models/DeleteSignatureImgResponseEntity';
import type { GetListCertificateEntity } from '../models/GetListCertificateEntity';
import type { HealthCheckCertificateDto } from '../models/HealthCheckCertificateDto';
import type { PaginatedSignatureImgResponseEntity } from '../models/PaginatedSignatureImgResponseEntity';
import type { PaginatedSigningDocumentResponseEntity } from '../models/PaginatedSigningDocumentResponseEntity';
import type { SignatureImgResponseEntity } from '../models/SignatureImgResponseEntity';
import type { SigningDocumentResponseEntity } from '../models/SigningDocumentResponseEntity';
import type { TextStampDto } from '../models/TextStampDto';
import type { UpdateCertificateDto } from '../models/UpdateCertificateDto';
import type { UpdateCertificateResponseEntity } from '../models/UpdateCertificateResponseEntity';
import type { UpdateCertificateStatusDto } from '../models/UpdateCertificateStatusDto';
import type { UpdateSignatureImgDto } from '../models/UpdateSignatureImgDto';
import type { UpdateSignatureImgResponseEntity } from '../models/UpdateSignatureImgResponseEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DigitalSignatureService {
  /**
   * Liệt kê tất cả chứng thư số đang hoạt động của người dùng đã xác thực
   * @param id Lọc theo ID chứng thư số.
   * @param status Lọc trạng thái chứng thư số.
   * @param certName Tìm gần đúng theo tên chứng thư số.
   * @param unit Lọc theo đơn vị sử dụng.
   * @param createdFrom Thời gian tạo từ (createdAt).
   * @param createdTo Thời gian tạo đến (createdAt).
   * @param isDefault Lọc theo chứng thư mặc định.
   * @returns GetListCertificateEntity
   * @throws ApiError
   */
  public static digitalSignatureControllerListCertificates(
    id?: string,
    status: 'ALL' | 'ACTIVE' | 'INACTIVE' = 'ALL',
    certName?: string,
    unit?: 'OTBP' | 'MRP' | 'MLP',
    createdFrom?: string,
    createdTo?: string,
    isDefault?: boolean,
  ): CancelablePromise<GetListCertificateEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/digital-signature/certificates',
      query: {
        id: id,
        status: status,
        certName: certName,
        unit: unit,
        createdFrom: createdFrom,
        createdTo: createdTo,
        isDefault: isDefault,
      },
    });
  }

  /**
   * Đăng ký chứng thư số CKS mới (xác thực số serial với Hilo)
   * @param requestBody
   * @returns CertificateResponseEntity Đăng ký chứng thư số thành công.
   * @throws ApiError
   */
  public static digitalSignatureControllerRegisterCertificate(
    requestBody: CreateCertificateDto,
  ): CancelablePromise<CertificateResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/digital-signature/certificates',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Cập nhật thông tin chứng thư số (keyAlias, unit)
   * @param id
   * @param requestBody
   * @returns UpdateCertificateResponseEntity Cập nhật chứng thư số thành công.
   * @throws ApiError
   */
  public static digitalSignatureControllerUpdateCertificate(
    id: string,
    requestBody: UpdateCertificateDto,
  ): CancelablePromise<UpdateCertificateResponseEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/digital-signature/certificates/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Vô hiệu hóa chứng thư số
   * @param id
   * @returns any Thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerDeleteCertificate(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/digital-signature/certificates/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * Bật hoặc tắt trạng thái chứng thư số
   * @param id
   * @param requestBody
   * @returns UpdateCertificateResponseEntity Cập nhật trạng thái chứng thư số thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerUpdateCertificateStatus(
    id: string,
    requestBody: UpdateCertificateStatusDto,
  ): CancelablePromise<UpdateCertificateResponseEntity> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v1/digital-signature/certificates/{id}/status',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Kiểm tra kết nối và xác thực chứng thư số với Hilo HSM
   * @param requestBody
   * @returns BaseResponseEntity
   * @throws ApiError
   */
  public static digitalSignatureControllerHealthCheckCertificate(
    requestBody: HealthCheckCertificateDto,
  ): CancelablePromise<BaseResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/digital-signature/certificates/health-check',
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Tải lên và ký tài liệu bằng chứng thư số đã đăng ký
   * @param formData
   * @returns SigningDocumentResponseEntity Ký tài liệu thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerSignDocument(formData: {
    file: Blob;
    certificateId: string;
    /**
     * Optional TextStampDto[] for PDF text stamps.
     */
    textStamps?: Array<TextStampDto>;
  }): CancelablePromise<SigningDocumentResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/digital-signature/document/sign',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Lấy danh sách phân trang các tài liệu đã ký của người dùng đã xác thực
   * @param startDate Ngày bắt đầu, định dạng ISO 8601 UTC+07:00.
   * @param endDate Ngày kết thúc, định dạng ISO 8601 UTC+07:00.
   * @param dateType Loại ngày lọc (createdAt: ngày tạo, signedAt: ngày đã ký)
   * @param status Lọc theo trạng thái ký
   * @param fileName Tên file (tìm kiếm gần đúng)
   * @param page Số trang
   * @param limit Số lượng mục trên mỗi trang
   * @returns PaginatedSigningDocumentResponseEntity Danh sách phân trang tài liệu đã ký
   * @throws ApiError
   */
  public static digitalSignatureControllerGetSigningDocumentHistory(
    startDate?: string,
    endDate?: string,
    dateType: 'createdAt' | 'signedAt' = 'createdAt',
    status: 'ALL' | 'INITIATED' | 'PROCESSING' | 'SIGNED' | 'FAILED' = 'ALL',
    fileName?: string,
    page: number = 1,
    limit: number = 20,
  ): CancelablePromise<PaginatedSigningDocumentResponseEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/digital-signature/document/history',
      query: {
        startDate: startDate,
        endDate: endDate,
        dateType: dateType,
        status: status,
        fileName: fileName,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Tải về tài liệu đã ký
   * @param id
   * @returns binary File tài liệu đã ký
   * @throws ApiError
   */
  public static digitalSignatureControllerDownloadSigningDocument(
    id: string,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/digital-signature/document/download/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * Xóa bản ghi tài liệu đã ký
   * @param id
   * @returns DeleteDocumentResponseEntity Thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerDeleteSigningDocument(
    id: string,
  ): CancelablePromise<DeleteDocumentResponseEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/digital-signature/document/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * Tải lên hình ảnh chữ ký mới cho người dùng
   * @param formData
   * @returns SignatureImgResponseEntity Tạo hình ảnh chữ ký thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerCreateSignatureImg(formData: {
    /**
     * File ảnh chữ ký (PNG/JPG, tối đa 5MB)
     */
    file: Blob;
    /**
     * Tên hiển thị cho chữ ký
     */
    name: string;
  }): CancelablePromise<SignatureImgResponseEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/digital-signature/signature-imgs',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * Lấy danh sách hình ảnh chữ ký của người dùng
   * @param name Tên hình ảnh chữ ký (kể cả orginal name)
   * @param isDefault Lọc theo trạng thái mặc định (ALL: tất cả | true: chỉ mặc định | false: không mặc định)
   * @param startDate Ngày bắt đầu (filter theo createdAt), định dạng ISO 8601 UTC+07:00.
   * @param endDate Ngày kết thúc (filter theo createdAt), định dạng ISO 8601 UTC+07:00.
   * @param page Số trang
   * @param limit Số bản ghi mỗi trang
   * @returns PaginatedSignatureImgResponseEntity Danh sách hình ảnh chữ ký
   * @throws ApiError
   */
  public static digitalSignatureControllerListSignatureImgs(
    name?: string,
    isDefault: 'ALL' | 'true' | 'false' = 'ALL',
    startDate?: string,
    endDate?: string,
    page: number = 1,
    limit: number = 20,
  ): CancelablePromise<PaginatedSignatureImgResponseEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/digital-signature/signature-imgs',
      query: {
        name: name,
        isDefault: isDefault,
        startDate: startDate,
        endDate: endDate,
        page: page,
        limit: limit,
      },
    });
  }

  /**
   * Lấy chi tiết một hình ảnh chữ ký
   * @param id
   * @returns SignatureImgResponseEntity Chi tiết hình ảnh chữ ký
   * @throws ApiError
   */
  public static digitalSignatureControllerGetSignatureImg(
    id: string,
  ): CancelablePromise<SignatureImgResponseEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/digital-signature/signature-imgs/{id}',
      path: {
        id: id,
      },
    });
  }

  /**
   * Cập nhật tên hoặc trạng thái mặc định của hình ảnh chữ ký
   * @param id
   * @param requestBody
   * @returns UpdateSignatureImgResponseEntity Cập nhật thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerUpdateSignatureImg(
    id: string,
    requestBody: UpdateSignatureImgDto,
  ): CancelablePromise<UpdateSignatureImgResponseEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/digital-signature/signature-imgs/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Xóa mềm hình ảnh chữ ký
   * @param id
   * @returns DeleteSignatureImgResponseEntity Xóa thành công
   * @throws ApiError
   */
  public static digitalSignatureControllerDeleteSignatureImg(
    id: string,
  ): CancelablePromise<DeleteSignatureImgResponseEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/digital-signature/signature-imgs/{id}',
      path: {
        id: id,
      },
    });
  }
}
